import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
/* Radix Colors — light mode scales (dark mode: swap to *-dark.css) */
import '@radix-ui/colors/iris.css';
import '@radix-ui/colors/mauve.css';
import '@radix-ui/colors/red.css';
import '@radix-ui/colors/amber.css';
import '@radix-ui/colors/green.css';

import './styles/tokens.css';
import './styles/app.css';

class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { error: null }; }
  static getDerivedStateFromError(error) { return { error }; }
  render() {
    if (this.state.error) {
      return React.createElement('pre', { style: { padding: 32, color: 'red', whiteSpace: 'pre-wrap' } },
        'CRASH: ' + this.state.error.message + '\n\n' + this.state.error.stack
      );
    }
    return this.props.children;
  }
}

createRoot(document.getElementById('root')).render(
  React.createElement(ErrorBoundary, null, React.createElement(App))
);
